import settingsIcon from '../../assets/icons/settings.svg';
import salesIcon from '../../assets/icons/shopping-bag.svg';
import calendarIcon from '../../assets/icons/calendarSidebarIcon.svg';
// import dashboardIcon from '../../assets/icons/dashboard-icon.svg';
import chatIcon from '../../assets/icons/chat-icon.svg';
import customersIcon from '../../assets/icons/customers-icon.svg';
import reportsIcon from '../../assets/icons/reports-icon.svg';
import taskBoardIcon from '../../assets/icons/taskBoardIcon.svg';
import diagnosticsIcon from '../../assets/icons/diagnostics-icon.svg';
import { ADMIN_USER_ROLE, DOCTOR_USER_ROLE, NURSE_USER_ROLE } from '../../constants/userRolesConstants';

export type SidebarEl = {
    label: string;
    icon: string;
    navigateTo?: string;
    subItems?: Array<{ label: string; navigateTo: string }>;
};

export const SIDEBAR_ELEMENTS: SidebarEl[] = [
    // {
    //     label: 'sidebar.dashboard',
    //     icon: dashboardIcon,
    //     navigateTo: '/web/dashboard',
    // },
    {
        label: 'schedule',
        icon: calendarIcon,
        navigateTo: '/web/schedule',
    },
    {
        label: 'Task Board',
        icon: taskBoardIcon,
        navigateTo: '/web/task-board',
    },
    {
        label: 'customers',
        icon: customersIcon,
        navigateTo: '/web/sales/customers',
    },
    {
        label: 'sidebar.chat',
        icon: chatIcon,
        navigateTo: '/web/chat',
    },
    {
        label: 'sidebar.sales',
        navigateTo: '/web/sales/orders',
        icon: salesIcon,
    },
    {
        label: 'reports',
        icon: reportsIcon,
        navigateTo: '/web/reports',
    },
    {
        label: 'sidebar.settings',
        icon: settingsIcon,
        subItems: [
            {
                label: 'calendar',
                navigateTo: '/web/calendar',
            },
            {
                label: 'support',
                navigateTo: '/web/support',
            },
        ],
    },
];

/**
 * Role-based sidebar configuration
 * Uses SIDEBAR_ELEMENTS for admin role and defines specific items for other roles
 */

export const ROLE_SIDEBAR_CONFIG: Record<string, SidebarEl[]> = {
    [ADMIN_USER_ROLE]: SIDEBAR_ELEMENTS,
    'diagnostic employee': [
        {
            label: 'sidebar.diagnostics',
            icon: diagnosticsIcon,
            subItems: [{ label: 'home.test', navigateTo: '/web/diagnostics/home-test' }],
        },
        {
            label: 'reports',
            icon: reportsIcon,
            subItems: [{ label: 'sidebar.diagnostics', navigateTo: '/web/diagnostics/reports' }],
        },
    ],
    [DOCTOR_USER_ROLE]: [
        // {
        //     label: 'sidebar.dashboard',
        //     icon: dashboardIcon,
        //     navigateTo: '/web/dashboard',
        // },
        {
            label: 'schedule',
            icon: calendarIcon,
            navigateTo: '/web/schedule',
        },
        {
            label: 'reports',
            icon: reportsIcon,
            navigateTo: '/web/reports',
        },
        {
            label: 'Task Board',
            icon: taskBoardIcon,
            navigateTo: '/web/task-board',
        },
        {
            label: 'sidebar.chat',
            icon: chatIcon,
            navigateTo: '/web/chat',
        },
    ],
    'sales employee': [
        {
            label: 'customers',
            icon: customersIcon,
            navigateTo: '/web/sales/customers',
        },
        {
            label: 'sidebar.sales',
            icon: salesIcon,
            navigateTo: '/web/sales/orders',
        },
    ],
    'care center agent': [
        // {
        //     label: 'sidebar.dashboard',
        //     icon: dashboardIcon,
        //     navigateTo: '/web/dashboard',
        // },
        {
            label: 'schedule',
            icon: calendarIcon,
            navigateTo: '/web/schedule',
        },
        {
            label: 'sidebar.chat',
            icon: chatIcon,
            navigateTo: '/web/chat',
        },
        {
            label: 'sidebar.settings',
            icon: settingsIcon,
            subItems: [
                {
                    label: 'support',
                    navigateTo: '/web/support',
                },
            ],
        },
    ],
    [NURSE_USER_ROLE]: [
        // {
        //     label: 'sidebar.dashboard',
        //     icon: dashboardIcon,
        //     navigateTo: '/web/dashboard',
        // },
        {
            label: 'schedule',
            icon: calendarIcon,
            navigateTo: '/web/schedule',
        },
        {
            label: 'customers',
            icon: customersIcon,
            navigateTo: '/web/sales/customers',
        },
        {
            label: 'Task Board',
            icon: taskBoardIcon,
            navigateTo: '/web/task-board',
        },
        {
            label: 'reports',
            icon: reportsIcon,
            navigateTo: '/web/reports',
        },
        {
            label: 'sidebar.sales',
            icon: salesIcon,
            navigateTo: '/web/sales/orders',
        },
        {
            label: 'sidebar.chat',
            icon: chatIcon,
            navigateTo: '/web/chat',
        },
        {
            label: 'sidebar.settings',
            icon: settingsIcon,
            subItems: [
                {
                    label: 'support',
                    navigateTo: '/web/support',
                },
            ],
        },
    ],
};

// Keep compatibility with the role names used before the current API roles.
ROLE_SIDEBAR_CONFIG.doctor = ROLE_SIDEBAR_CONFIG[DOCTOR_USER_ROLE];
ROLE_SIDEBAR_CONFIG.nurse = ROLE_SIDEBAR_CONFIG[NURSE_USER_ROLE];
